"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useLayoutEffect } from "react";
import { scroll, useMotionValue } from "@/hooks/useFramerMotion";
import { createDocumentScrollInput } from "./documentScrollInput";

// Share only the input. Each consumer still owns its MotionValue and springs.
// Motion retains responsibility for frame scheduling and resize measurement.
export const connectDocumentScrollY = createDocumentScrollInput(update => scroll((_progress, {
  y
}) => update(y.current, y.progress)), () => Math.abs(document.scrollingElement?.scrollTop ?? window.scrollY), y => {
  const root = document.documentElement;
  const range = root.scrollHeight - root.clientHeight;
  // Match Motion's progress semantics, including a non-scrollable document.
  return range ? y / range : 1;
});
const useClientLayoutEffect = typeof window === "undefined" ? useEffect : useLayoutEffect;
export function useDocumentScrollY() {
  const $ = _c(5);
  const scrollY = useMotionValue(0);
  let t0;
  let t1;
  if ($[0] !== scrollY) {
    t0 = () => connectDocumentScrollY(scrollY);
    t1 = [scrollY];
    $[0] = scrollY;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useClientLayoutEffect(t0, t1);
  let t2;
  if ($[3] !== scrollY) {
    t2 = {
      scrollY
    };
    $[3] = scrollY;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}